module.exports = __webpack_public_path__ + "static/media/white_instagram.302ab313.png";